export const SET_CONTENT = 'environment/SET_CONTENT'
export const SET_MODE = 'environment/SET_MODE'
